export * from './RuntimeBlocks'
export * from './ConsensusBlocks'
export * from './RecentBlocks'
export enum BlocksTableType {
  Mobile,
  DesktopLite,
  Desktop,
}
